@if (comparisonStat) {
  <span class="flex items-center gap-2 text-4xl font-bold text-steel-100"
    >{{ comparisonStat.start | number: '1.0-1' }} <rma-icon glyph="arrow_forward" /> {{ comparisonStat.end | number: '1.0-1' }}</span
  >
  <span class="flex flex-wrap text-sm text-steel-70">{{ label }}</span>
}
